import { useQuery } from '@tanstack/react-query';
import { requestVideoKeys } from '../api/keys';
import { fetchActivityDates } from '../api/requestVideoApi';
import { STALE_TIME } from '../utils/constants';
import { groupDayKeys } from '../utils/timeZone';

const NO_DAYS = [];

export const useActivityDays = ({ activityUnitId, timeZone }) => {
  const enabled = Boolean(activityUnitId);
  const query = useQuery({
    queryKey: requestVideoKeys.days(activityUnitId, timeZone),
    queryFn: () => fetchActivityDates({ activityUnitId }),
    select: (timestamps) => groupDayKeys(timestamps, timeZone),
    staleTime: STALE_TIME.days,
    enabled,
  });

  return {
    days: query.data || NO_DAYS,
    isLoading: enabled && query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
};
